import { AlarmFlags } from './alarm-flags';
import { ChannelFcuData, ChannelFcuDataFns } from './channel-fcu-data';
import { ChannelOpsData, ChannelOpsDataFns } from './channel-ops-data';
import {
    ChannelType,
    ChannelTypeStrings,
    isAnalog,
    isBlank,
    isDigital,
    isRunningHour,
} from './channel-type';

export class Channel {
    id: string;
    groupId: string;
    opsData: ChannelOpsData;
    fcuData: ChannelFcuData;
    rowIndex?: number;
    groupName?: String;
    checked?: Boolean;
}

export enum FlagOption {
    UNDEFINED = 'undefined',
    HIGH_HIGH = 'highHigh',
    LOW_LOW = 'lowlow',
    HIGH = 'high',
    LOW = 'low',
    NORMAL = 'normal',
    FEEDBACK = 'feedbackError',
    OVER = 'over',
    UNDER = 'under',
}

export const ChannelFns = {
    create,
    scaleValue,
    transformValue,
    isChannelBlank,
    isDigital: isChannelDigital,
    isAnalog: isChannelAnalog,
    isRunningHour: isChannelRunningHour,
    setChannelType,
    getStatusString,
    getAlarmClass,
};


function create(): Channel {
    let fcuData = ChannelFcuDataFns.create();
    let opsData = ChannelOpsDataFns.create();

    return {
        id: '',
        groupId: '',
        opsData: opsData,
        fcuData: fcuData,
    };
}

function getAlarmClass(alarmFlag: AlarmFlags): FlagOption {
    if (alarmFlag.highHigh == 1) {
        return FlagOption.HIGH_HIGH;
    } else if (alarmFlag.lowlow == 1) {
        return FlagOption.LOW_LOW;
    } else if (alarmFlag.low == 1) {
        return FlagOption.LOW;
    } else if (alarmFlag.high == 1) {
        return FlagOption.HIGH;
    } else if (alarmFlag.feedbackError == 1) {
        return FlagOption.FEEDBACK;
    } else if (alarmFlag.over == 1) {
        return FlagOption.OVER;
    } else if (alarmFlag.under == 1) {
        return FlagOption.UNDER;
    } else {
        return FlagOption.NORMAL;
    }
}

function getStatusString(flagOption: FlagOption) {
    switch (flagOption) {
        case FlagOption.NORMAL:
            return 'channel.flag.alarm.normal';
        case FlagOption.HIGH_HIGH:
            return 'channel.flag.alarm.high-high';
        case FlagOption.LOW_LOW:
            return 'channel.flag.alarm.low-low';
        case FlagOption.LOW:
            return 'channel.flag.alarm.low';
        case FlagOption.HIGH:
            return 'channel.flag.alarm.high';
        case FlagOption.FEEDBACK:
            return 'channel.flag.alarm.feedback';
        case FlagOption.OVER:
            return 'channel.flag.alarm.over';
        case FlagOption.UNDER:
            return 'channel.flag.alarm.under';
        case FlagOption.UNDEFINED:
            return '';
        default:
            return '';
    }
}

function transformValue(channel: Channel, value: number) {
    if (!value || isNaN(value)) return ' - ';
    const currentValue = isChannelDigital(channel)
        ? getDigitalString(channel, value)
        : scaleValue(channel, value);
    return Number.isNaN(currentValue) ? ' - ' : currentValue;
}

function scaleValue(channel: Channel, value: number) {
    return value / channel.fcuData.scale;
}

function getDigitalString(channel: Channel, value: number) {
    return value
        ? channel.fcuData.digitalAlarmSetting.statusStringContactOn
        : channel.fcuData.digitalAlarmSetting.statusStringContactOff;
}

function isChannelBlank(channel: Channel): boolean {
    return isBlank(channel.fcuData.channelType);
}

function isChannelDigital(channel: Channel): boolean {
    return isDigital(channel.fcuData.channelType);
}

function isChannelAnalog(channel: Channel): boolean {
    return isAnalog(channel.fcuData.channelType);
}

function isChannelRunningHour(channel: Channel): boolean {
    return isRunningHour(channel.fcuData.channelType);
}

function setChannelType(channel: Channel, type: ChannelType) {
    channel.opsData.channelType = ChannelTypeStrings[type];
    channel.fcuData.channelType = type;
}
